var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarNotfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4132 17.8781L17.1382 20.8781C17.7476 21.2625 18.4976 20.6906 18.3195 19.9875L16.9507 14.6063C16.9137 14.4571 16.9196 14.3005 16.9677 14.1546C17.0158 14.0086 17.1042 13.8792 17.2226 13.7813L21.4601 10.2469C22.0132 9.78752 21.732 8.8594 21.0101 8.81252L15.4789 8.45627C15.3279 8.44749 15.1828 8.39494 15.0613 8.30503C14.9398 8.21513 14.847 8.09177 14.7945 7.95002L12.732 2.75627C12.6774 2.60618 12.5779 2.47653 12.4471 2.38491C12.3163 2.29329 12.1604 2.24414 12.0007 2.24414C11.841 2.24414 11.6852 2.29329 11.5544 2.38491C11.4235 2.47653 11.3241 2.60618 11.2695 2.75627L9.20698 7.95002C9.15441 8.09177 9.0617 8.21513 8.94016 8.30503C8.81862 8.39494 8.67353 8.44749 8.5226 8.45627L2.99135 8.81252C2.26948 8.8594 1.98823 9.78752 2.54135 10.2469L6.77885 13.7813C6.89729 13.8792 6.98565 14.0086 7.03375 14.1546C7.08186 14.3005 7.08774 14.4571 7.05073 14.6063L5.7851 19.5938C5.56948 20.4375 6.46948 21.1219 7.19135 20.6625L11.5882 17.8781C11.7115 17.7997 11.8546 17.7581 12.0007 17.7581C12.1468 17.7581 12.2899 17.7997 12.4132 17.8781Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarNotfill);
export default __webpack_public_path__ + "static/media/star_notfill.3d9747b7d54e7bdb0c1a6a9d0b437032.svg";
export { ForwardRef as ReactComponent };